import { useEffect } from "react";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://hagelundtoemrer.dk").replace(/\/$/, "");
const SITE_NAME = "Hagelund";
const DEFAULT_IMAGE = `${SITE_URL}/images/hero.webp`;

// Helper — set or create a <meta> tag by name or property.
function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(path) {
  const href = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return href;
}

/**
 * Set per-page SEO: title, description, canonical, OG tags.
 * Robots defaults to index,follow. Pass noindex=true to block.
 */
export default function usePageMeta({ title, description, image, path, noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Specialister i døre og vinduer`;
    document.title = fullTitle;

    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    const canonical = setCanonical(path || window.location.pathname);

    const absImage = image ? (image.startsWith("http") ? image : `${SITE_URL}${image.startsWith("/") ? image : `/${image}`}`) : DEFAULT_IMAGE;

    // Open Graph
    setMeta("property", "og:title", fullTitle);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:image", absImage);

    // Twitter
    setMeta("name", "twitter:title", fullTitle);
    if (description) setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", absImage);
  }, [title, description, image, path, noindex]);
}
